import type { FunctionComponent } from 'react'
import React, { useContext, useRef, useState } from 'react'

import { constructDate } from '../../../../shared/components/DatePicker/formatDate/constructDate'
import { DatePickerPage } from '../../../../shared/pages/DatePickerPage'
import { ToolContext } from '../../../../shared/state/appContext'
import type { DatePickerInputRef } from '../../../../shared/types/toolTypes'
import { cleanText } from '../../../../shared/utils/cleanText'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { getDatePickerValidationErrorMessage } from '../../../../shared/utils/getDatePickerValidationErrorMessage/getDatePickerValidationErrorMessage'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { TicketDateFlow, TicketLocationFlow } from '../../pageFlowData'
import { data } from './data'

export const TicketDate: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    ticket: { ticketDate },
  } = state

  const TicketDateInput = useRef<DatePickerInputRef>(null)

  const [datePickerError, setDatePickerError] = useState('')

  /* v8 ignore next */
  const getValue = () => {
    return cleanText(TicketDateInput?.current?.datePickerInput?.value || ticketDate)
  }

  const handleTracking = (value: string) => {
    const trackingAnswer = `question | ${TicketDateFlow.VIEW_NAME} | ${value}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleDispatch = (value: string) => {
    dispatch({ type: 'UPDATE_TICKET_DATE', data: value })
    dispatch({ type: 'UPDATE_STEP', data: TicketLocationFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: TicketLocationFlow.PROGRESS_VALUE })
  }

  /* v8 ignore next */
  const handleInputChange = (value: string) => {
    /* v8 ignore next */
    dispatch({ type: 'UPDATE_TICKET_DATE', data: value })
  }

  const handleSubmit = () => {
    setDatePickerError('')
    const dateInputValue: string = getValue()
    const errorMessage = getDatePickerValidationErrorMessage(dateInputValue)
    /* v8 ignore next */
    if (errorMessage) {
      return setDatePickerError(errorMessage)
    }
    handleTracking(dateInputValue)
    handleDispatch(dateInputValue)
  }

  const { imgObj, title } = data

  return (
    <DatePickerPage
      buttonText="Next"
      handleInputChange={handleInputChange}
      handleSubmit={handleSubmit}
      imgObj={imgObj}
      isFocused
      max={constructDate(new Date(), false)}
      newErrorMessage={datePickerError}
      purchasedDate={ticketDate}
      ref={TicketDateInput}
      renderError={datePickerError !== ''}
      testId="ticket-date-page"
      title={title}
    />
  )
}
